import { Box, BoxProps } from '@mui/material';

export const MuiPage = (props: BoxProps) => {
    const { children, ...other } = props

    return (
        <Box px={2} py={1} {...other}>
            {children}
        </Box>
    )
}
